import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Button from "sushiweb/Button";
import { useParams, useHistory } from "react-router-dom";

import CountryFormModal from "../../components/Country/CountryFormModal";
import CountryList from "../../components/Country/CountryList";
import * as CountryActions from "../../store/actions/Country";
import ListPagination from "../../components/Common/ListPagination";
import * as UserActions from "../../store/actions/User";
import ErrorMsgs from "../../constants/Errors.json";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getPath } from "../../utils";
import { FlexContainer, Heading } from "../../constants/assets/containers";

const Country = (props) => {
  const params = useParams();
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.COUNTRY];

  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  useEffect(() => {
    if (shouldRenderList === true) {
      props.getCountryList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  const handleClick = (type, id) => {
    setModalState(type);
    setActiveId(id);
  };

  const deleteCountryHandler = (id) => {
    props
      .deleteCountry(id)
      .then((res) => {
        const pageRequest = { page: currentPage };
        props.getCountryList({}, pageRequest);
      })
      .catch((err) => {
        props.setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        });
      });
  };

  const handleModalClose = () => {
    setActiveId(null);
    setModalState(false);
    props.resetState({ state: "activeCountry" });
    if (
      history.location.pathname !== "/countries" &&
      getPath(props.countryList, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/countries");
    } else if (
      history.location.pathname !== "/countries" &&
      getPath(props.countryList, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/countries");
    }
  };

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getCountryList({}, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getCountryList({}, pageRequest);
    }
  };

  const getModal = () => {
    return (
      <CountryFormModal
        activeId={activeId}
        modalState={modalState}
        handleModalClose={handleModalClose}
      />
    );
  };

  return (
    <div className="Country-View container">
      <FlexContainer align="flex-start">
        <Heading>Countries</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="CountriesAddBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.LIST]}>
        <CountryList
          countryList={props.countryList}
          deleteCountry={deleteCountryHandler}
        />
      </Permission>
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {!!modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { Country } = state;
  return {
    countryList: Country.countryList,
    nextPage: Country.nextPage,
    prevPage: Country.prevPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    resetState: bindActionCreators(CountryActions.resetState, dispatch),
    deleteCountry: bindActionCreators(CountryActions.deleteCountry, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Country);
